import axios from 'axios';

const actions = {
	// Riepilogo della Home: KPI con confronto, andamento, canali e top prodotti/brand/categorie
	asyncFetchSummary: async (context, params) => {
		const res = await axios.get(`${context.rootGetters['settings/getUrl']}dashboard/summary`, {
			params,
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
		});
		return res.data.data;
	},
	// previsione di fine del mese in corso (null senza storico sufficiente)
	asyncFetchForecast: async (context, params) => {
		const res = await axios.get(`${context.rootGetters['settings/getUrl']}forecast/month`, {
			params,
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
		});
		return res.data.data;
	},
};

export default {
	namespaced: true,
	state: {},
	mutations: {},
	getters: {},
	actions,
};
